import { NEXT_URL_PARAM_KEY } from "../common/env";

export function getNextUrlFromParams(
  params: URLSearchParams = new URLSearchParams(window.location.search)
): string | null {
  return params.get(NEXT_URL_PARAM_KEY);
}
